<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>

    <main class="container py-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <h4 class="fw-bold mb-0">Support Tickets</h4>
                <div class="text-muted small">Manage user support requests and conversations</div>
            </div>

            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadTickets()">
                Refresh
            </button>
        </div>

        <div class="row g-3 mb-3" *ngIf="summary">
            <div class="col-md-3">
                <div class="card shadow-sm border-0 h-100 cursor-pointer" (click)="filterUnresolved()">
                    <div class="card-body">
                        <div class="text-muted small">Unresolved</div>
                        <div class="fs-4 fw-bold">{{ summary.totalUnresolved }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card shadow-sm border-0 h-100 cursor-pointer" (click)="filterByStatus('Open')">
                    <div class="card-body">
                        <div class="text-muted small">Open</div>
                        <div class="fs-4 fw-bold">{{ summary.totalOpen }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card shadow-sm border-0 h-100 cursor-pointer" (click)="filterByStatus('WaitingForAdmin')">
                    <div class="card-body">
                        <div class="text-muted small">Waiting For Admin</div>
                        <div class="fs-4 fw-bold">{{ summary.totalWaitingForAdmin }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card shadow-sm border-0 h-100 cursor-pointer" (click)="filterByStatus('Resolved')">
                    <div class="card-body">
                        <div class="text-muted small">Resolved</div>
                        <div class="fs-4 fw-bold">{{ summary.totalResolved }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card shadow-sm border-0 h-100 cursor-pointer">
                    <div class="card-body">
                        <div class="text-muted small">Due Soon</div>
                        <div class="fs-4 fw-bold text-warning">{{ summary.totalDueSoon }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card shadow-sm border-0 h-100 cursor-pointer">
                    <div class="card-body">
                        <div class="text-muted small">Overdue</div>
                        <div class="fs-4 fw-bold text-danger">{{ summary.totalOverdue }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card shadow-sm border-0 mb-3">
            <div class="card-body">
                <div class="row g-3 align-items-end">
                    <div class="col-md-4">
                        <label class="form-label">Search</label>
                        <input type="text" class="form-control" [(ngModel)]="search"
                            placeholder="Search subject or source" />
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Status</label>
                        <select class="form-select" [(ngModel)]="status">
                            <option value="">All</option>
                            <option *ngFor="let item of statuses" [value]="item">{{ item }}</option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Category</label>
                        <select class="form-select" [(ngModel)]="category">
                            <option value="">All</option>
                            <option *ngFor="let item of categories" [value]="item">{{ item }}</option>
                        </select>
                    </div>

                    <div class="col-md-2">
                        <label class="form-label">Priority</label>
                        <select class="form-select" [(ngModel)]="priority">
                            <option value="">All</option>
                            <option *ngFor="let item of priorities" [value]="item">{{ item }}</option>
                        </select>
                    </div>

                    <div class="col-12 d-flex gap-2">
                        <button class="btn btn-primary btn-sm" type="button" (click)="loadTickets()">
                            Apply
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="clearFilters()">
                            Clear
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card shadow-sm border-0">
            <div class="card-body">
                <div *ngIf="loading" class="text-center py-4">
                    <div class="spinner-border spinner-border-sm"></div>
                </div>

                <div *ngIf="!loading && !tickets.length" class="text-center text-muted py-4">
                    No support tickets found.
                </div>

                <div *ngIf="tickets.length" class="table-responsive">
                    <table class="table align-middle">
                        <thead>
                            <tr>
                                <th>Subject</th>
                                <th>Category</th>
                                <th>Status</th>
                                <th>SLA</th>
                                <th>Priority</th>
                                <th>Updated</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let t of tickets" [class.table-warning]="t.status === 'WaitingForAdmin'">
                                <td>{{ t.subject }}</td>
                                <td>{{ t.category }}</td>
                                <td><span class="badge" [ngClass]="{
                                        'bg-primary': t.status === 'Open',
                                        'bg-warning text-dark': t.status === 'WaitingForAdmin',
                                        'bg-info text-dark': t.status === 'WaitingForUser',
                                        'bg-secondary': t.status === 'InProgress',
                                        'bg-success': t.status === 'Resolved',
                                        'bg-dark': t.status === 'Closed'}">
                                        {{ t.status }}
                                    </span></td>
                                <td>
                                    <span class="badge" [ngClass]="{
      'bg-danger': t.sla.isBreached,
      'bg-warning text-dark': t.sla.isDueSoon && !t.sla.isBreached,
      'bg-success': !t.sla.isBreached && !t.sla.isDueSoon && t.status !== 'Resolved' && t.status !== 'Closed',
      'bg-secondary': t.status === 'Resolved' || t.status === 'Closed'
    }">
                                        <ng-container *ngIf="t.status === 'Resolved' || t.status === 'Closed'">
                                            Resolved
                                        </ng-container>
                                        <ng-container *ngIf="t.status !== 'Resolved' && t.status !== 'Closed'">
                                            {{ t.sla.stage }} ·
                                            <span *ngIf="t.sla.isBreached">Overdue</span>
                                            <span *ngIf="!t.sla.isBreached && t.sla.isDueSoon">Due Soon</span>
                                            <span *ngIf="!t.sla.isBreached && !t.sla.isDueSoon">On Track</span>
                                        </ng-container>
                                    </span>
                                </td>
                                <td>{{ t.priority }}</td>
                                <td>{{ t.lastUpdatedAt | date:'short' }}</td>
                                <td>
                                    <div class="d-flex flex-wrap gap-2">
                                        <a [routerLink]="['/admin/support', t.id]"
                                            class="btn btn-sm btn-outline-primary">
                                            Open
                                        </a>
                                        <button *ngIf="t.status === 'Open'" class="btn btn-sm btn-outline-success"
                                            (click)="quickUpdateStatus(t.id, 'InProgress')">
                                            Start
                                        </button>

                                        <button *ngIf="t.status === 'WaitingForAdmin'"
                                            class="btn btn-sm btn-outline-success"
                                            (click)="quickUpdateStatus(t.id, 'Resolved')">
                                            Resolve
                                        </button>

                                        <a *ngIf="t.status !== 'Resolved' && t.status !== 'Closed'"
                                            [routerLink]="['/admin/support', t.id]" [queryParams]="{ action: 'reply' }"
                                            class="btn btn-sm btn-outline-secondary">
                                            Reply
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </main>
</div>